import parsePathString from './parse-path-string';
var REGEX_MD = /[a-z]/;
function toSymmetry(p, c) {
    return [
        c[0] + (c[0] - p[0]),
        c[1] + (c[1] - p[1]),
    ];
}
export default function pathToAbsolute(pathString) {
    var pathArray = parsePathString(pathString);
    if (!pathArray || !pathArray.length) {
        return [
            ['M', 0, 0],
        ];
    }
    var needProcess = false; // å¦æå­å¨å°åçå½ä»¤æè V,H,T,S åéè¦å¤ç
    for (var i = 0; i < pathArray.length; i++) {
        var cmd = pathArray[i][0];
        // å¦æå­å¨ç¸å¯¹ä½ç½®çå½ä»¤ï¼åä¸­æ­è¿å
        if (REGEX_MD.test(cmd) || ['V', 'H', 'T', 'S'].indexOf(cmd) >= 0) {
            needProcess = true;
            break;
        }
    }
    // å¦æä¸å­å¨ç¸å¯¹å½ä»¤ï¼åç´æ¥è¿å
    // å¦æå¨ä¸å¡ä¸é½åç»å¯¹è·¯å¾ï¼è¿ç§æ¹å¼æå¿«ï¼ä»åäºä¸æ¬¡æ£æµ
    if (!needProcess) {
        return pathArray;
    }
    var res = [];
    var x = 0;
    var y = 0;
    var mx = 0;
    var my = 0;
    var start = 0;
    var pa0;
    var dots;
    var first = pathArray[0];
    if (first[0] === 'M' || first[0] === 'm') {
        x = +first[1];
        y = +first[2];
        mx = x;
        my = y;
        start++;
        res[0] = ['M', x, y];
    }
    for (var i = start, ii = pathArray.length; i < ii; i++) {
        var pa = pathArray[i];
        var preParams = res[i - 1]; // ååä¸ä¸ªå·²ç»å¤çåçèç¹ï¼å¦åä¼åºç°é®é¢
        var r = [];
        var cmd = pa[0];
        var upCmd = cmd.toUpperCase();
        if (cmd !== upCmd) {
            r[0] = upCmd;
            switch (upCmd) {
                case 'A':
                    r[1] = pa[1];
                    r[2] = pa[2];
                    r[3] = pa[3];
                    r[4] = pa[4];
                    r[5] = pa[5];
                    r[6] = +pa[6] + x;
                    r[7] = +pa[7] + y;
                    break;
                case 'V':
                    r[1] = +pa[1] + y;
                    break;
                case 'H':
                    r[1] = +pa[1] + x;
                    break;
                case 'M':
                    mx = +pa[1] + x;
                    my = +pa[2] + y;
                    r[1] = mx;
                    r[2] = my;
                    break; // for lint
                default:
                    for (var j = 1, jj = pa.length; j < jj; j++) {
                        r[j] = +pa[j] + ((j % 2) ? x : y);
                    }
            }
        }
        else { // å¦ææ¬æ¥å·²ç»å¤§åï¼åä¸å¤ç
            r = pathArray[i];
        }
        // éè¦å¨å¤é¢ç»ä¸åï¼åæ¶å¤ç V,H,S,T ç­ç¹æ®æä»¤
        switch (upCmd) {
            case 'Z':
                x = +mx;
                y = +my;
                break;
            case 'H':
                x = r[1];
                r = ['L', x, y];
                break;
            case 'V':
                y = r[1];
                r = ['L', x, y];
                break;
            case 'T':
                x = r[1];
                y = r[2];
                // ä»¥ x, y ä¸ºä¸­å¿çï¼ä¸ä¸ä¸ªæ§å¶ç¹çå¯¹ç§°ç¹
                // éè¦åè®¾ä¸ä¸ä¸ªèç¹çå½ä»¤ä¸º Q
                var symetricT = toSymmetry([preParams[1], preParams[2]], [preParams[3], preParams[4]]);
                r = ['Q', symetricT[0], symetricT[1], x, y];
                break;
            case 'S':
                x = r[r.length - 2];
                y = r[r.length - 1];
                // ä»¥ x,y ä¸ºä¸­å¿ï¼åä¸ä¸ä¸ªæ§å¶ç¹ï¼
                // éè¦åè®¾ä¸ä¸ä¸ªçº¿æ®µä¸º C æè S
                var length_1 = preParams.length;
                var symetricS = toSymmetry([preParams[length_1 - 4], preParams[length_1 - 3]], [preParams[length_1 - 2], preParams[length_1 - 1]]);
                r = ['C', symetricS[0], symetricS[1], r[1], r[2], x, y];
                break;
            case 'M':
                mx = r[r.length - 2];
                my = r[r.length - 1];
                break; // for lint
            default:
                x = r[r.length - 2];
                y = r[r.length - 1];
        }
        res.push(r);
    }
    return res;
}
//# sourceMappingURL=path-2-absolute.js.map